import * as React from "react";

import KitsScreen from "../../../componets/KitsScreen";

const Inward = () => {
  return <KitsScreen type="inward"/>;
};

export default Inward;
